export const IG_ISOTYPE_OPTION = { label: 'Ig isotype', value: 'igIsotype' };
export const CELL_TYPE_OPTION = { label: 'Cell type', value: 'cellType' };
export const LEIDEN_CLUSTER_OPTION = {
  label: 'Leiden cluster',
  value: 'leidenCluster',
};
export const CLONOTYPE_SIZE_OPTION = {
  label: 'Clonotype size',
  value: 'clonotypeSize',
};
// export const TOP_CLONOTYPES_OPTION = {
//   label: 'Top 15 Clonotypes',
//   value: 'topClonotypes',
// };
export const VH_FAMILY_OPTION = { label: 'VH-gene family', value: 'vhFamily' };
